import { Enumify } from 'enumify';

class TabulatorCellFormatter extends Enumify {
  static ACTIONS = new TabulatorCellFormatter();
  static ARRAY = new TabulatorCellFormatter();
  static BEATING_HEART = new TabulatorCellFormatter();
  static CHECK_STATUS = new TabulatorCellFormatter();
  static COLOR = new TabulatorCellFormatter();
  static CONCATENATE = new TabulatorCellFormatter();
  static CONDITION = new TabulatorCellFormatter();
  static DATE_DUE = new TabulatorCellFormatter();
  static EMAIL = new TabulatorCellFormatter();
  static FINANCE_ESTIMATE = new TabulatorCellFormatter();
  static FINANCE_ESTIMATE_STATUS = new TabulatorCellFormatter();
  static FONT_AWESOME_ICON = new TabulatorCellFormatter();
  static IMAGE = new TabulatorCellFormatter();
  static IMAGE_MULTIPLE = new TabulatorCellFormatter();
  static LINK = new TabulatorCellFormatter();
  static MONEY = new TabulatorCellFormatter();
  static NUMBER = new TabulatorCellFormatter();
  static PERCENTAGE = new TabulatorCellFormatter();
  static PO_STATUS = new TabulatorCellFormatter();
  static SALES_ORDER_STATUS = new TabulatorCellFormatter();
  static SHORT_NUMBER = new TabulatorCellFormatter();
  static TELEPHONE = new TabulatorCellFormatter();
  static TEXT_BLOCK = new TabulatorCellFormatter();
  static TRAILER_CONFIG_STATUS = new TabulatorCellFormatter();
  static WEBROTATE = new TabulatorCellFormatter();
  static XERO = new TabulatorCellFormatter();
  static _ = this.closeEnum();

  lowerEnumKey() {
    return this.enumKey.toLowerCase();
  }
}

export default TabulatorCellFormatter;
